import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'emergency_exit_doors_do_not_open_outwards_are'

export const dataPointDefinition = {
  retracedId: 'emergency_exit_doors_do_not_open_outwards_are',
  name: 'Emergency exit doors do not open outwards or are not securely kept open during working hours',
  description:
    'The intent is to determine if emergency exit doors are already securely open at any time during working hours (e.g. rolling doors are always open and workers can exit without opening any doors) or if emergency exit doors which are usually closed open outward in direction of egress. ',
  meta: {
    slcpMeta: {
      key: 'hs-eme-28x',
      number: 'HS-EME-16-2',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-eme-28x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 30740,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
